import { getAccessoryProperties } from "modules/products"
import { SUBSIDY_TYPE_NONE } from "modules/subsidies"
import { calcHelper } from "services/utils"
import * as globalData from "views/constants/jsonData/globalData"

export const matchProducts = (data, scooterStore) => {
  let productGroup = []

  const newArray = data.Product.sort((prev, next) => prev.Sort - next.Sort)
    .map((obj) => {
      // 取得所有的分類
      if (productGroup.indexOf(obj.Group) === -1) {
        productGroup.push(obj.Group)
      }

      const allGt = scooterStore.currentModel.SeriesProductCode === "ggr1" ? "x" : "z"

      // [site, model, mod]
      const CodeNameArray = getAccessoryProperties(obj)

      obj._site = CodeNameArray[0]
      obj._gt = CodeNameArray[1] && CodeNameArray[1] === "all" ? allGt : CodeNameArray[1]
      obj._mod = CodeNameArray[2]
      obj._selected = 0

      if (obj.Color && obj.Color.length > 0) {
        // 配件顏色按鈕圖片
        obj.Color.map((colorObj) => {
          colorObj._code = colorObj.ColorCode || colorObj.ColorIcon.replace(".png", "").replace("color_chip_", "")
          colorObj._selected = 0
          return colorObj
        })
        // filter retail sell
        obj.Sell = calcHelper.getSellState(obj.Sell)
      } else {
        obj.Sell = 0
      }

      return obj
    })
    .filter((pro) => (pro.Status === 2 || pro.Status === 3) && pro.Bag === 1 && pro.Sell !== 0)

  return [newArray, productGroup]
}

export const matchComboProducts = (comboProduct) => {
  return comboProduct.map((combo) => {
    combo.PromotionProduct.sort((prev, next) => prev.Sort - next.Sort)
      .map((obj) => {
        const CodeNameArray = getAccessoryProperties(obj)
        obj._site = CodeNameArray[0]
        obj._selected = 0

        if (obj.Color && obj.Color.length > 0) {
          // 配件顏色按鈕圖片
          obj.Color.forEach((colorObj) => {
            colorObj._code = colorObj.ColorCode || colorObj.ColorIcon.replace(".png", "").replace("color_chip_", "")
            colorObj._selected = 0
          })
          // filter retail sell
          obj.Sell = calcHelper.getSellState(obj.Sell)
        } else {
          obj.Sell = 0
        }
        return obj
      })
      .filter((pro) => (pro.Status === 2 || pro.Status === 3) && pro.Bag === 1 && pro.Sell !== 0)

    return combo
  })
}

export const getCurrentProductImage = (color) => {
  // TODO move to modules/products
  const selectedColor = color.filter((colorObj) => colorObj._selected === 1)[0]
  const imgUrl = selectedColor
    ? selectedColor.ProductColorImage.ColorImageFile
    : color[0].ProductColorImage.ColorImageFile

  return `${globalData.initAccessoryAWSUrl}upload/product/${imgUrl}` // online store 配件圖是用正式機
}

export const discountText = ({
  subsidyType,
  subsidyCountyName,
  localSubsidyName,
  isTES,
  isEPA,
  isEPB,
  tesSubsidyName,
}) => {
  if (subsidyType === SUBSIDY_TYPE_NONE) return "不申請政府補助"

  if (isTES === true && isEPA === false && isEPB === false) {
    return `產業發展署-${tesSubsidyName}`
  }

  return `${subsidyCountyName}${localSubsidyName}`
}

export const checkHexColorBrightness = (color) => {
  if (!color) return "light"

  const rgb = parseInt(color.substring(1), 16) // convert rrggbb to decimal
  const red = (rgb >> 16) & 0xff // extract red
  const green = (rgb >> 8) & 0xff // extract green
  const blue = (rgb >> 0) & 0xff // extract blue

  const luma = 0.2126 * red + 0.7152 * green + 0.0722 * blue // per ITU-R BT.709

  if (luma > 235) return "light"
  return "dark"
}
